import { z } from "zod";

import { GENDER, ProfileStatus, ProfileType } from "@/constants/profile";
import { careplanPendingActionSchema } from "@/schemas/careplan";
import { profileToDataModel } from "@/transformers/profile-to-data-model";

export const profileTypeSchema = z.nativeEnum(ProfileType);
export const profileStatusSchema = z.nativeEnum(ProfileStatus);
export const genderSchema = z.nativeEnum(GENDER);

export const profileSchema = z.object({
  id: z.number(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phone: z.string(),
  birthDate: z.string().nullable(),
  age: z.number().nullable(),
  origin: z.string().nullable(),
  referredBy: z.string().optional(),
  type: profileTypeSchema,
  isTestUser: z.boolean(),
  gender: genderSchema,
  smsEnabledAt: z.string().nullable(),
  emailsEnabledAt: z.string().nullable(),
  klaviyoProfileId: z.string().nullable(),
  profilingId: z.number(),
  createdAt: z.string(),
  lastSession: z.string().nullable(),
  status: profileStatusSchema,
  careplanRequiresReview: z.boolean(),
  careplanRequiresAdminReview: z.boolean(),
  careplanDays: z.number(),
  careplanPendingAction: careplanPendingActionSchema.nullable(),
  totalDays: z.number(),
  isLegacy: z.boolean(),
  preferences: z.object({
    presentationsToAvoid: z.record(z.string(), z.boolean()),
    productsToAvoid: z.record(z.string(), z.boolean()),
    roleToAvoid: z.record(z.string(), z.boolean()),
  }),
  hasMessagesPendingToBeReadByAdmins: z.boolean().nullable(),
});

export const editProfileSummaryFormSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  email: z.email(),
  phone: z.string(),
  birthDate: z.string().nullable(),
  gender: genderSchema,
  referredBy: z.string().optional(),
  caregiver: z.boolean(),
  isTestUser: z.boolean(),
  preferences: z.object({
    presentationsToAvoid: z.array(z.string()).optional(),
    productsToAvoid: z.array(z.string()).optional(),
    roleToAvoid: z.array(z.string()).optional(),
  }),
  status: z.enum(ProfileStatus),
  emailNotificationsEnabled: z.boolean(),
  smsNotificationsEnabled: z.boolean(),
});

export const editProfileSummaryRequestSchema = editProfileSummaryFormSchema.extend({
  id: z.number(),
});

export const profileDataModelSchema = profileSchema.transform(profileToDataModel);
